export default __webpack_public_path__ + "images/referenzen/socialmedia/rosenthal_kollektionsfilm.mp4";